var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.snackbar.success)?_c('div',{staticClass:"z-10 fixed left-1/4 right-1/4 bottom-1 text-center bg-green-200 rounded-xl text-white p-2"},[_vm._v(" SUCCESS ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }